export const NOTICE_ATTR_NAME = 'data-notice-name';
export const NOTICE_ATTR_TYPE = 'data-notice-type';
export const NOTICE_ATTR_ROLE = 'data-notice-role';
export const NOTICE_ATTR_STATE = 'data-state';
export const NOTICE_TOAST_TYPE = 'toast';
export const NOTICE_COMMUNITCATION_TYPE = 'communication';
export const NOTICE_ON_SHOW_EVENT = 'showNotice';
export const TOAST_TIME = 2750;
